<template>
  <div class="global-chat-active-chat-messages-container__message">
    <div class="global-chat-active-chat-messages-container__bubble">
      <div class="global-chat-active-chat-messages-container__content-text">
        {{lang.get('event_strings.global-chat.empty_chat_placeholder_text')}}
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['message']
};
</script>

<style scoped>
.global-chat-active-chat-messages-container__content-text {
  white-space: normal;
}
</style>